import { render } from "./CreateTypeMarchandise.vue?vue&type=template&id=77311b55"
import script from "./CreateTypeMarchandise.vue?vue&type=script&lang=js"
export * from "./CreateTypeMarchandise.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__